module.exports = __webpack_public_path__ + "img/4c.dd594115.svg";